export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  REPLY_ALL: 'REPLY_ALL',
  FORWARD: 'FORWARD',
  TEMPLATE: 'TEMPLATE',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
